import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class TransitionToHelper extends Helper {
  @service router;

  compute([route]) {
    return route ? () => this.router.transitionTo(route) : null;
  }
}
